import db from '@/firebase/init'
import moment from "moment";
import * as firebase from "../../firebase";

export function modulloadOnlineUser(ref, onlineusers,router){
     // let ref = db.collection('friends').orderBy('name')
  console.log("modulloadOnlineUser")
      ref.onSnapshot(snapshot => {
        snapshot.forEach(change => {
          if(change.data().name!=router.name){
            onlineusers.push({
              id: change.id,
              name: change.data().name,
              alter: change.data().alter,
              region: change.data().region,
              img: change.data().img,
              geolocation: change.data().geolocation,
              // timestamp: moment(change.data().timestamp).format('lll'),
            })
          }
        })
      })
}

export function modulloadOnlineImgs(ref, data,router){
      const datafriends=[];
      //let ref = db.collection('friends').orderBy('name')
      ref.get().then(snapshot => {
        snapshot.forEach(change => {
          if(change.data().name!=router.name){
            datafriends.push({
              id: change.id,
              img: change.data().img,
            })
          }
        })
      }).then(()=>{
        modulfillCarousel(datafriends,data);
      })
        .catch(err => {
          console.log('Error modulloadOnlineImgs', err);
        });
    }

export function modulfillCarousel(content, data) {
      let input;
         for(let i=0;i<3;i++){
        input= '<div class="example-slide">';
        input+='<img src="'+content[i].img+'" style="height: 150px; width: 300px">' ;
        input+='<img src="'+content[i+1].img+'" style="height: 150px; width: 300px;margin-left: 30px;">' ;
        input+='<img src="'+content[i+2].img+'" style="height: 150px; width: 300px;margin-left: 30px;">' ;
        input+='</div>';
        data.push(input)
      }
}




// WEBPACK FOOTER //
// ./src/firebase/OnlineDBFunction.js